import ContinueToRead from './ContinueToRead'
import withContinueToRead from './withContinueToRead'

const ConnectedContinueToRead = withContinueToRead(ContinueToRead)

export { ConnectedContinueToRead as ContinueToRead }
